import styled from '@emotion/styled';
import Typography from 'aquilla/core/atoms/Typography';
import { Spacings } from '@styles/index';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: ${Spacings.SPACING_4B};
`;

const BaseTextContainer = styled.div`
  cursor: pointer;
`;

const GoalBreadcrumb = ({ baseOnClickHandler, breadcrumbData }) => {
  const { baseText, textArray, separator } = breadcrumbData;
  let breadcrumbText = '';
  for (let idx = 0; idx < textArray?.length; idx += 1) {
    if (idx < textArray?.length - 1) {
      breadcrumbText += textArray[idx];
      breadcrumbText += `\u00A0${separator}\u00A0`;
    } else {
      breadcrumbText += textArray[idx];
    }
  }

  return (
    <Container>
      <BaseTextContainer onClick={baseOnClickHandler}>
        <Typography variant="p1" color="var(--color-i-gray-13)">
          {baseText} {separator}&nbsp;
        </Typography>
      </BaseTextContainer>
      <Typography variant="h5" color="var(--color-i-black)">
        {breadcrumbText}
      </Typography>
    </Container>
  );
};

export default GoalBreadcrumb;
